import { ActionType } from '../../types/general';

export const NavigationActions = {
    drawerToggled: (open: boolean, variant: 'persistent' | 'temporary' | 'permanent') =>
        ({
            type: 'Navigation/DrawerToggled',
            payload: { open, variant },
        } as const),
} as const;

export type NavigationActions = ActionType<typeof NavigationActions>;
